import { BuilderState } from '@/types/builder';
import React from 'react';
import Image from 'next/image';
import Card from '@tempcover/bolt-ui/card';
import { JourneyType, LandingPageForm } from '../LandingPageForm/LandingPageForm';
import TrustPilotWidget, { TrustpilotLayouts } from '../TrustPilot/TrustPilot';

interface ProductPageHeaderProps {
  title: string;
  subtitle?: string;
  image: string;
  regLabel: string;
  showRegLabel?: boolean;
  showRegToggle?: boolean;
  defaultDurationType?: string;
  daysOnly?: boolean;
  useBanner?: boolean;
  bannerCoverType?: string;
  bannerCoverDuration?: string;
  checkboxLabel?: string;
  formIntroText?: string;
  submitButtonText?: string;
  submitButtonColor?: 'orange' | 'purple';
  builderState: BuilderState;
  journey: JourneyType;
  regPlateOnly: boolean;
  showDurationPicker?: boolean;
}

const FormLayout: React.FC<{ props: ProductPageHeaderProps }> = ({ props }) => (
  <div className="grid md:grid-cols-[auto_1fr] md:grid-rows-[1fr_min-content_2fr] md:items-center md:gap-x-20 md:align-middle">
    <div className="order-2 !h-auto md:order-1 md:row-span-3 md:max-w-[375px]">
      <Card>
        <LandingPageForm
          journey={props.journey}
          regLabel={props.regLabel}
          showRegLabel={props.showRegLabel}
          showRegToggle={props.showRegToggle}
          defaultDurationType={props.defaultDurationType}
          daysOnly={props.daysOnly}
          useBanner={props.useBanner}
          bannerCoverType={props.bannerCoverType}
          bannerCoverDuration={props.bannerCoverDuration}
          checkboxLabel={props.checkboxLabel}
          formIntroText={props.formIntroText}
          submitButtonText={props.submitButtonText}
          submitButtonColor={props.submitButtonColor}
          regPlateOnly={props.regPlateOnly}
          showDurationPicker={props.showDurationPicker}
        />
      </Card>
      <div className="mt-2 hidden h-[80px] md:block">
        <TrustPilotWidget variant="light" layout={TrustpilotLayouts.Micro} />
      </div>
    </div>

    <h1 className="order-1 mt-0 self-end pt-0 md:mb-5">{props.title}</h1>
    <div className="order-2">
      {props.subtitle && <h2 className="tc-heading-sm mb-0 p-0 md:mt-0">{props.subtitle}</h2>}
    </div>

    <div className="relative order-3 min-h-[200px] self-start">
      <Image
        src={props.image}
        alt={props.title}
        fill
        className="object-contain"
        sizes="(max-width: 768px) 100vw, 50vw"
        priority
        fetchPriority="high"
      />
    </div>
  </div>
);

export const PageHeroImage: React.FC<ProductPageHeaderProps> = (props) => {
  return (
    <div className="tc-container pt-8">
      <FormLayout props={props} />
    </div>
  );
};
